import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getPortalSettings } from '../../redux/actions/UserActions';

class CreateCaseSuccess extends React.Component {
  state = {
    authorized: this.props.location.isauthorized,
    message: localStorage.getItem('confirmationMessage') || ''
  };

  componentDidMount() {
    this.props.getPortalSettings();
  }

  render() {
    const { t } = this.props;
    
    if (!this.state.authorized) {
     return <Redirect to="/CreateClient" />;
    }

    return (
      <div style={{ background: "#eceff0", minHeight: '100vh' }}>
        <div className={"header-" + window.globalConfig.CustomerName + " container-fluid"}>
          <div className="row align-items-center">
            <div className="col-6 d-flex">
              <div className="logo">
                <Link to="/">
                  <img 
                    src={localStorage.getItem('publicportallogo')} 
                    height="100%" 
                    alt="Portal Logo"
                    onError={(e) => e.target.style.display = 'none'}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="success-wrapper">
          <div className="success-container">
            <div className="success-icon-wrapper">
              <svg width="80" height="80" viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="38" fill="#28a745" opacity="0.15" />
                <circle cx="40" cy="40" r="32" fill="none" stroke="#28a745" strokeWidth="3" />
                <path 
                  d="M25 40 L35 50 L55 30" 
                  stroke="#28a745" 
                  strokeWidth="4" 
                  fill="none" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h2 className="success-title">{this.state.message}</h2>
          </div>
        </div>

        <style jsx>{`
          .success-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 4rem 2rem;
          }

          .success-container {
            background: white;
            padding: 3rem 2rem;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            max-width: 600px;
            width: 100%;
            text-align: center;
          }

          .success-icon-wrapper {
            margin-bottom: 2rem;
            animation: successBounce 0.6s ease-out;
          }

          @keyframes successBounce {
            0% {
              transform: scale(0) rotate(-180deg);
              opacity: 0;
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1) rotate(0deg);
              opacity: 1;
            }
          }

          .success-title {
            font-size: 1.8rem;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 1rem;
            line-height: 1.4;
          }

          .success-subtitle {
            color: #6c757d;
            font-size: 1.1rem;
            margin-bottom: 1.5rem;
          }

          @media (max-width: 576px) {
            .success-container {
              padding: 2rem 1.5rem;
            }

            .success-title {
              font-size: 1.5rem;
            }

            .success-subtitle {
              font-size: 1rem;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default connect(
  null,
  { getPortalSettings }
)(withTranslation('common')(CreateCaseSuccess));
